export const valueForManyKeys = <K extends keyof any, V>(object: Record<K, V>, keys: K[]): V | undefined => {
  if (!object) return undefined
  for (const key of keys) {
    if (Object.hasOwn(object, key)) {
      return object[key]
    }
  }
  return undefined
}
